import { render, staticRenderFns } from "./DocumentsCreate.vue?vue&type=template&id=78c9aa1b&scoped=true"
import script from "./DocumentsCreate.vue?vue&type=script&lang=js"
export * from "./DocumentsCreate.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCreate.vue?vue&type=style&index=0&id=78c9aa1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9aa1b",
  null
  
)

export default component.exports